






























































































































import Vue from "vue";
import { MODULE_COLORS } from "@/utility/Constants";

// Model
import { UpdateTypeEnum, GetI18nStringFromUpdateType } from "@/model/data/enums/UpdateTypeEnum";
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";

export default Vue.extend({
    data() {
        return {
            VersionObfuscator,
            MODULE_COLORS,
            UpdateTypeEnum,
        };
    },
    props: { updatePackage: {} },
    methods: { GetI18nStringFromUpdateType },
});
